import React from 'react';
import './Switch.css';

import classes from './Switch.css';

const Switch = (props) => {
  return (
        <div className={classes.Switch}>
            <div className={classes.SwitchHelper}>
                <input
                  className={classes.ReactSwitchCheckbox}
                  checked={props.isOn}
                  onChange={props.handleToggle}
                  id={`react-switch-new`}
                  type="checkbox"
                />
                <label
                className={classes.ReactSwitchLabel}
                htmlFor={`react-switch-new`}
                >
                <span className={classes.ReactSwitchButton} />
                </label>
                <p>Show Info</p>
            </div>
        </div>  
  );
};

export default Switch;


// WEBPACK FOOTER //
// ./src/components/UI/Buttons/Switch/Switch.js